/**
 * Validates whether an address is within Ohio by calling our backend proxy,
 * which in turn calls the US Census Geocoding API server-side (avoids CORS).
 * @param {string} address - The one-line address (e.g. "123 Main St, Columbus, OH 43201")
 * @returns {Promise<{valid: boolean, error?: string}>}
 */
export async function validateOhioAddress(address) {
  if (!address || !address.trim()) {
    return { valid: false, error: "Address is required." };
  }

  // Use the same local/prod URL pattern as the rest of the app
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const base = isLocal
    ? "http://localhost:8081"
    : "https://ultimatesroofing.com/api";

  const url = `${base}/ultimates/validate-address?address=${encodeURIComponent(address.trim())}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    // Backend returns { valid: true } or { valid: false, error: "..." }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error validating address:", error);
    return {
      valid: false,
      error: "Couldn't verify address, please try again.",
    };
  }
}
